export const MicrocopyTitles = {
  OVERVIEW_TEXT: 'overviewText',
  CLIENT: 'client',
  PARTNER: 'partner',
  LOGO_TEXT: 'logoText',
}
